import { useState } from 'react';

import { useParams } from 'react-router-dom';

import { useMobileStore } from 'store/mobile.store';
import { useVersionStore } from 'store/version.store';

import { useQueryGetCard } from 'api/queries/getMainCard.query';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';

export const useMainCardProvider = () => {
    const [showModal, setShowModal] = useState(true);
    const isMobile = useMobileStore((state) => state.isMobile);

    const { cardId } = useParams<{ cardId: string }>();
    const currentVersion = useVersionStore((state) => state.version);

    const getCard = useQueryGetCard({
        id: cardId,
        isVirtual: false,
        versionId: window.location.href.indexOf(executionConfig.pinboards.link) === -1 ? currentVersion?.id : undefined,
    });

    return {
        showModal,
        setShowModal,
        isMobile,
        api: {
            getCard,
        },
    };
};
